import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {
  WorkflowId,
  WorkflowInput,
  WorkflowInputId,
} from "common/flowmaster/types/workflow";

export type WorkflowInputReorderAction = {
  type: WorkflowsActionTypes["WORKFLOW_INPUT_REORDER"]["SUCCESS"];
  payload: WorkflowInput[];
};

export default function reorderWorkflowInput(requestor) {
  return createReduxPromiseAction(
    ActionTypes.WORKFLOW_INPUT_REORDER,
    (
      organisationId: OrganisationId,
      workflowId: WorkflowId,
      workflowInputId: WorkflowInputId,
      order: number,
    ) => {
      return requestor
        .post(
          `${basePath}/organisation/${organisationId}` +
            `/workflow/${workflowId}/input/${workflowInputId}/reorder`,
          {order},
          {withCredentials: true},
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
